export default __webpack_public_path__ + "static/24-2ea3e29feffe97caaff5524ef3df9aba.jpg";